import { render, staticRenderFns } from "./PromotionLogicalCondition.vue?vue&type=template&id=18666d95&"
import script from "./PromotionLogicalCondition.vue?vue&type=script&lang=ts&"
export * from "./PromotionLogicalCondition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports